<%= form_with(model: question, class: "contents") do |form| %>
  <% if question.errors.any? %>
    <div id="error_explanation" class="bg-red-50 text-red-500 px-3 py-2 font-medium rounded-md mt-3">
      <h2><%= pluralize(question.errors.count, "error") %> prohibited this question from being saved:</h2>

      <ul class="list-disc ml-6">
        <% question.errors.each do |error| %>
          <li><%= error.full_message %></li>
        <% end %>
      </ul>
    </div>
  <% end %>

  <div class="my-5">
    <%= form.label :billable_id %>
    <%= form.text_field :billable_id, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": question.errors[:billable_id].none?, "border-red-400 focus:outline-red-600": question.errors[:billable_id].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :question_text %>
    <%= form.textarea :question_text, rows: 4, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": question.errors[:question_text].none?, "border-red-400 focus:outline-red-600": question.errors[:question_text].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :question_type %>
    <%= form.text_field :question_type, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": question.errors[:question_type].none?, "border-red-400 focus:outline-red-600": question.errors[:question_type].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :choices %>
    <%= form.textarea :choices, rows: 4, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": question.errors[:choices].none?, "border-red-400 focus:outline-red-600": question.errors[:choices].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :order %>
    <%= form.number_field :order, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": question.errors[:order].none?, "border-red-400 focus:outline-red-600": question.errors[:order].any?}] %>
  </div>

  <div class="inline">
    <%= form.submit class: "w-full sm:w-auto rounded-md px-3.5 py-2.5 bg-blue-600 hover:bg-blue-500 text-white inline-block font-medium cursor-pointer" %>
  </div>
<% end %>
